import { createElement } from 'react';
import { Modal as OriginalProModal, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import { BaseDialog } from '../../shared/base/BaseDialog';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
export default class ProModal extends BaseDialog {
    render() {
        ConfigProvider.config({
            theme: {
                primaryColor: '#f16622',
            },
        });
        const innerProps = this.transformProps();
        return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
            createElement(OriginalProModal, { ...this.props, ...innerProps, onClose: innerProps.onCancel })));
    }
}
